import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e46d2f46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=e46d2f46&prod&scoped=true&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=e46d2f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46d2f46",
  null
  
)

export default component.exports